<template>
<div class="userdatawizard_page abspage nohpage">

	<maincontent>
		<template v-slot:content>
            <div class="cnt">
                <template v-if="!currentProblem">
                    <div class="ready">
                        <div class="caption">
                            <span>{{$t('labels.startready')}}</span>
                        </div>
                        <button class="button orange" @click="start">
                            {{$t('labels.start')}}
                        </button>
                    </div>
                </template>

                <template v-if="currentProblem == 'locale'">
                    <setlocale @change="check"/>
                </template>

                <template v-if="currentProblem == 'bday'">
                    <bday @change="check"/>
                </template>

            </div>
		</template>
	</maincontent>

</div>
</template>

<style scoped lang="sass">
    .userdatawizard_page
        display: flex
        align-items: center
        justify-content: center

        .ready
            text-align: center

            .caption
                padding-left: 2 * $r
                padding-right: 2 * $r
                margin-bottom: 3 * $r
                span
                    font-weight: 100
                    font-size: 2em

</style>

<script>

import bday from "@/components/modules/profile/bday/index.vue";
import setlocale from "@/components/modules/profile/locale/index.vue";

import f from "@/application/shared/functions.js";

export default {
	name: 'userdatawizard_page',
	components: {
        bday,
        setlocale
	},

	computed: {
        locales : function(){
            return f.deep(this.core, 'appInfo.snippity.settings.locales') || []
        }
	},

    watch: {
        currentProblem : function(){
            if(!this.currentProblem){
                setTimeout(() => {
                    this.start()
                }, 2000)
            }
        }
    },

	methods: {
        start : function(){
            this.$router.push('/').catch(e => {})
        },

        check : function(){

            this.currentProblem = this.core.user.checkInfo()
        }
	},

    data : function(){

        return {
            currentProblem : null
        }

    },

	mounted() {
        this.check()
	}
}
</script>
